var serializer = function($httpParamSerializerJQLike) {
  return function (params) {
    var res = $httpParamSerializerJQLike(params);
    return res.replace(/;/g,'%3B');
  };
};


serializer.$inject = ['$httpParamSerializerJQLike'];

tiz.service('$httpCustomSerializer', serializer);